module.exports = __webpack_public_path__ + "static/media/S_A.16a5448e.png";